export const initPhoneCallGoal = () => {
  const header = document.getElementById('phone-number-header');
  const footer = document.getElementById('phone-number-footer');
  const accommodation = document.getElementById('phone-number-accommodation');
  const quote = document.getElementById('phone-number-quote');
  const carousel = document.getElementById('phone-number-carousel');
  const paymentSuccess = document.getElementById('phone-number-payment-success');
  const bookingSuccess = document.getElementById('phone-number-booking-success');

  if (footer) {
    footer.addEventListener('click', () => {
      sendEvent();
    }, true);
  }

  if (header) {
    header.addEventListener('click', () => {
      sendEvent();
    }, true);
  }

  if (accommodation) {
    accommodation.addEventListener('click', () => {
      sendEvent();
    }, true);
  }

  if (quote) {
    quote.addEventListener('click', () => {
      sendEvent();
    }, true);
  }

  if (carousel) {
    carousel.addEventListener('click', () => {
      sendEvent();
    }, true);
  }

  if (paymentSuccess) {
    paymentSuccess.addEventListener('click', () => {
      sendEvent();
    }, true);
  }

  if (bookingSuccess) {
    bookingSuccess.addEventListener('click', () => {
      sendEvent();
    }, true);
  }
};

const sendEvent = () => {
  ga('send', 'event', 'Phone number clicked');
};
